import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  Alert,
  CreateButton,
  CRUDLayout,
  DataStatus,
  FilterButton,
  InputSearch,
  Pagination,
  ReadButton,
  TBody,
  Td,
  TdFixed,
  Th,
  THead,
  ThFixed,
  Tr,
} from 'components';
import { TransferAlatMesinWorkOrderApi } from 'api';
import { DateConvert, DecimalConvert, PageNumber } from 'utilities';
import { ModalFilterPage, ModalFormTransfer } from './components';
import { withDropdownProvider } from './context/DropdownContext';

export const ListTransferAlatMesinWorkOrder = withDropdownProvider(
  ({ setNavbarTitle }) => {
    const history = useHistory();
    const location = useLocation();
    const title = 'Transfer Alat Mesin Work Order';
    const filter = location.state?.filter ?? {};

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [totalPage, setTotalPage] = useState(1);
    const [totalData, setTotalData] = useState('');
    const [modalFilter, setModalFilter] = useState(false);
    const [dataFilter, setDataFilter] = useState({
      active: filter.pre?.active,
      page: filter.pre?.page ?? 1,
      per_page: filter.pre?.per_page ?? 10,
      q: filter.pre?.q ?? '',

      tgl_transfer_work_order_alat_mesin_mulai:
        filter.pre?.tgl_transfer_work_order_alat_mesin_mulai,
      tgl_transfer_work_order_alat_mesin_selesai:
        filter.pre?.tgl_transfer_work_order_alat_mesin_selesai,

      tgl_permintaan_work_order_alat_mesin_mulai:
        filter.pre?.tgl_permintaan_work_order_alat_mesin_mulai,
      tgl_permintaan_work_order_alat_mesin_selesai:
        filter.pre?.tgl_permintaan_work_order_alat_mesin_selesai,
      id_item_aset: filter.pre?.id_item_aset,
      id_karyawan: filter.pre?.id_karyawan,
    });

    const [modal, setModal] = useState(false);
    const [dataModal, setDataModal] = useState({});
    const [searchTime, setSearchTime] = useState(null);
    const [alertConfig, setAlertConfig] = useState({
      show: false,
      variant: 'primary',
      text: '',
    });

    const getData = () => {
      setIsLoading(true);

      const filterData = { ...dataFilter };
      delete filterData.active;

      TransferAlatMesinWorkOrderApi.page(filterData)
        .then((res) => {
          setData(res.data.data);
          setTotalPage(res.data.total_page);
          setTotalData(res.data.data_count);
        })
        .catch(() => {
          setAlertConfig({
            show: true,
            variant: 'danger',
            text: 'Data gagal dimuat!',
          });
        })
        .finally(() => setIsLoading(false));
    };

    const checkAlert = () => {
      const locationState = location.state;

      if (locationState) {
        if (locationState.alert) {
          setAlertConfig({
            show: locationState.alert.show,
            text: locationState.alert.text,
            variant: locationState.alert.variant,
          });
        }
      }
    };

    const onInputSearch = (text) => {
      const key = text.target.value;
      if (searchTime) clearTimeout(searchTime);
      setSearchTime(
        setTimeout(() => {
          setDataFilter({
            ...dataFilter,
            page: '1',
            q: key,
          });
          setAlertConfig({
            show: key ? true : false,
            variant: 'primary',
            text: 'Hasil dari pencarian: ' + key,
          });
        }, 750),
      );
    };

    useEffect(() => {
      setNavbarTitle(title);
      checkAlert();

      // eslint-disable-next-line
    }, [setNavbarTitle]);

    useEffect(() => {
      getData();

      // eslint-disable-next-line
    }, [dataFilter]);

    const toggleModal = () => setModal(!modal);

    const toggleModalFilter = () => setModalFilter(!modalFilter);

    const Table = () => {
      return (
        <>
          <b>List Data {title}</b>
          <CRUDLayout.Table>
            <THead>
              <Tr>
                <ThFixed>No</ThFixed>
                <ThFixed>Aksi</ThFixed>
                <ThFixed>Informasi Transfer Alat Mesin Work Order</ThFixed>
                <ThFixed>Informasi Permintaan Work Order</ThFixed>
                <Th>Item Alat Mesin</Th>
                <ThFixed>Qty. Transfer</ThFixed>
                <Th>Diserahkan Oleh</Th>
                <Th>Keterangan Transfer</Th>
              </Tr>
            </THead>
            <TBody>
              {data.map((val, index) => (
                <Tr key={index}>
                  <TdFixed textCenter>
                    {PageNumber(dataFilter.page, dataFilter.per_page, index)}
                  </TdFixed>
                  <TdFixed>
                    <ReadButton
                      size="sm"
                      onClick={() => {
                        setDataModal(val);
                        toggleModal();
                      }}
                    />
                  </TdFixed>
                  <Td>
                    <div>
                      {val.tgl_transfer_work_order_alat_mesin
                        ? DateConvert(
                            new Date(val.tgl_transfer_work_order_alat_mesin),
                          ).defaultDMY
                        : '-'}
                    </div>
                    <div>{val.no_transfer_work_order_alat_mesin ?? '-'}</div>
                  </Td>
                  <Td>
                    <div>
                      {val.tgl_permintaan_work_order_alat_mesin
                        ? DateConvert(
                            new Date(val.tgl_permintaan_work_order_alat_mesin),
                          ).defaultDMY
                        : '-'}
                    </div>
                    <div>{val.no_permintaan_work_order_alat_mesin ?? '-'}</div>
                  </Td>
                  <Td>{val.nama_item ?? '-'}</Td>
                  <Td className="text-right">{`${
                    DecimalConvert(val.qty_transfer_work_order_alat_mesin ?? 0)
                      .getWithComa
                  } ${val.nama_satuan ?? ''}`}</Td>
                  <Td>{val.nama_karyawan ?? '-'}</Td>
                  <Td>{val.keterangan_transfer ?? '-'}</Td>
                </Tr>
              ))}
            </TBody>
          </CRUDLayout.Table>
          <Pagination
            dataLength={dataFilter.per_page}
            dataPage={
              totalData <= 10
                ? data.length
                : data.map((_res, index) => {
                    if (index === data.length - 1) {
                      return PageNumber(
                        dataFilter.page,
                        dataFilter.per_page,
                        index,
                      );
                    } else {
                      return null;
                    }
                  })
            }
            dataNumber={data.map((_res, index) => {
              if (index === 0) {
                return PageNumber(dataFilter.page, dataFilter.per_page, index);
              } else {
                return null;
              }
            })}
            dataCount={totalData}
            onDataLengthChange={(e) => {
              setDataFilter({
                ...dataFilter,
                per_page: e.target.value,
                page: 1,
              });
            }}
            currentPage={dataFilter.page}
            totalPage={totalPage}
            onPaginationChange={({ selected }) =>
              setDataFilter({
                ...dataFilter,
                page: selected + 1,
              })
            }
          />
        </>
      );
    };

    return (
      <CRUDLayout>
        <CRUDLayout.Head>
          <CRUDLayout.HeadSearchSection>
            <div className="d-flex mb-3">
              <InputSearch onChange={onInputSearch} />

              <FilterButton
                active={dataFilter?.active}
                onClick={toggleModalFilter}
              />
            </div>
          </CRUDLayout.HeadSearchSection>

          <CRUDLayout.HeadButtonSection>
            <CreateButton
              onClick={() => {
                history.push(
                  '/transaksi/transfer-alat-mesin-work-order/list-permintaan-work-order',
                  {
                    filter: {
                      ...filter,
                      pre: dataFilter,
                    },
                  },
                );
              }}
            />
          </CRUDLayout.HeadButtonSection>
        </CRUDLayout.Head>

        <Alert
          show={alertConfig.show}
          variant={alertConfig.variant}
          text={alertConfig.text}
          showCloseButton={true}
          onClose={() => {
            setAlertConfig({
              ...alertConfig,
              show: false,
            });
            history.replace('/transaksi/transfer-alat-mesin-work-order', {
              registerAlertConfig: undefined,
            });
          }}
        />

        {isLoading ? (
          <DataStatus loading={true} text="Memuat data..." />
        ) : data.length ? (
          <Table />
        ) : (
          <DataStatus text="Tidak ada data" />
        )}

        {modal && (
          <ModalFormTransfer
            data={dataModal}
            title={title}
            toggle={toggleModal}
          />
        )}

        {modalFilter && (
          <ModalFilterPage
            toggle={toggleModalFilter}
            data={dataFilter}
            setData={setDataFilter}
          />
        )}
      </CRUDLayout>
    );
  },
);
